export const forumUrl = 'https://pingkai.cn/tidbcommunity/forum';
export const blogUrl = 'https://pingkai.cn/tidbcommunity/blog';
